var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShadeBlocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.352,
    y: 24.955,
    width: 32.792,
    height: 33.702,
    fill: "none",
    stroke: "#868686",
    strokeDashoffset: 10,
    strokeWidth: 7.9459
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.337,
    y: 74.782,
    width: 32.792,
    height: 33.702,
    fill: "none",
    stroke: "#72b0fe",
    strokeDashoffset: 10,
    strokeWidth: 7.9459
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadeBlocks);
export default __webpack_public_path__ + "static/media/shade_blocks.89597f91f8ca04d62e336d6636069296.svg";
export { ForwardRef as ReactComponent };